module.exports = __webpack_public_path__ + "img/1.88fa3a0c.png";